module.exports = __webpack_public_path__ + "img/CM-MS-24-Mitsubishi-Playful.f631da1a.jpg";